import { gql, useMutation } from '@apollo/client'

export const UNSUBSCRIBE_TO_PUSH_NOTIFICATIONS = gql`
  mutation ($user_id: String!) {
    unSubscribeFromPushNotifications(user_id: $user_id)
  }
`

export const useUnsubscribeToPushNotifications = () => {
  const [mutate, { data, error, loading }] = useMutation(UNSUBSCRIBE_TO_PUSH_NOTIFICATIONS)

  return { mutate, data, error, loading }
}
